"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MemoryBuffer = _interopRequireDefault(require("./MemoryBuffer"));

var _rootLocalStore = _interopRequireDefault(require("./rootLocalStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootMemoryBuffer = new _MemoryBuffer.default(); // 将本地数据与内存数据同步

_rootLocalStore.default.getAll().then(function (data) {
  return rootMemoryBuffer.initData(data);
});

var _default = rootMemoryBuffer;
exports.default = _default;